import client from './index'

export type TypeCar = 'ice' | 'ev'

export interface RegisterCarPayload {
  car_number: string
  car_profile_id?: string
  ev_car_profile_id?: string
  type: TypeCar
}

export interface RegisterCarLogsParams {
  car_profile_id?: string
  ev_car_profile_id?: string
}

export interface PaperPayload {
  type: TypeCar

  trip_id?: string
  ev_trip_id?: string

  car_number?: string
  license_series?: string
  license_number?: string | number
  birth_date?: string // YYYY-MM-DD
  expire_date?: string // YYYY-MM-DD
  duration_month?: number
  duration_day?: number
  duration_hour?: number
}

export interface CancelPaperPayload {
  type: TypeCar
  trip_id?: string
  ev_trip_id?: string
  paper_id?: string
}

export interface GetTripPaperParams {
  trip_id?: string
  ev_trip_id?: string
}

export interface GetActivityLogsParams {
  id: string
}

export interface GetActivityLogByIdParams {
  id: string
}

export interface GetTripPaperLogsParams {
  trip_id?: string
  ev_trip_id?: string
  car_profile_id?: string
  ev_car_profile_id?: string
  user_id?: string
  end_date?: string
}

export const registerCar = (payload: RegisterCarPayload) =>
  client.post(`portal/register-car`, payload)

export const deleteCar = (id: string) =>
  client.delete(`portal/delete-car`, { data: { id } })

export const getRegisterCarInfo = (params: RegisterCarLogsParams) =>
  client.get(`portal/register-car`, { params })

export const getRegisterCarLogs = (params: RegisterCarLogsParams) =>
  client.get(`portal/register-car-logs`, { params })

export const createPaper = (payload: PaperPayload) =>
  client.post(`portal/create-paper`, payload)

export const cancelPaper = (payload: CancelPaperPayload) =>
  client.post(`portal/cancel-paper`, payload)

export const getTripPaper = (params: GetTripPaperParams) =>
  client.get(`portal/trip-paper`, { params })

export const getActivityLogsByRelationId = (params: GetActivityLogsParams) =>
  client.get(`portal/user-logs`, { params })

export const getActivityLogById = (params: GetActivityLogByIdParams) =>
  client.get(`portal/log`, { params })

export const getPaperLogs = (params: GetTripPaperLogsParams) =>
  client.get(`portal/request-log`, { params })
